<template>
    <div :class="getClasses()" :style="modstyle ?? null">
        <div v-if="this.useHeader" :class="'p-4 pb-0 card-header' + (this.headerclass ? ' ' + this.headerclass : '')" :style="getHeaderStyles()">
            <div class="d-flex justify-content-between align-items-start">
                <h5 v-if="this.title" class="mb-0">{{ this.title }}</h5>
                <slot name="header-action"></slot>
            </div>
        </div>
        <div :class="getClassesBody()">
            <slot></slot>
        </div>
        <div v-if="this.useFooter" :class="'card-footer' + (this.footerclass ? this.footerclass : '')" :style="getFooterStyles()">
            <slot name="footer"></slot>
        </div>
    </div>
</template>
<style scoped>
.btn {
    margin-bottom: 0!important;
}
.card-body.with-min {
    min-height: 57.6vh;
}
.card-body {
  padding-top: 0!important;
  display: flex;
  justify-content: stretch;
  flex-direction: column;
  position: relative;
}
.card-footer {
    padding-top: 1rem!important;
    padding-bottom: 1rem!important;
}
</style>
<script>
export default {
    props: {
        p: {
            type: Number,
            required: false,
        },
        asTabs: {
            type: Boolean,
            default:false,
        },
        title: {
            type: String
        },
        classes: {
            type: String,
            default: "",
        },
        withmin: {
            type: Boolean,
            default: true,
        },
        headerstyle: String,
        headerclass: String,
        footerstyle: String,
        footerclass: String,
        useFooter: Boolean,
        useHeader: Boolean,
        modstyle: String,
    },
    methods: {
        getClasses() {
            let data = {}
            data['card border-radius-sm position-relative'] = true;
            data['p-4'] = true;
            data[this.classes] = true;
            return data
        },
        getClassesBody() {
            let data = {
                "card-body": true,
                "with-min": this.withmin,
            }
            data['p-' + (this.p == 0?'0':this.p)] = (this.p == 0?'p-0':this.p)
            return data;
        },
        getHeaderStyles() {
            let style = [];
            if (this.headerstyle) {
                style.push(this.headerstyle)
            }

            return style.join(';');
        },
        getFooterStyles() {
            let style = [];
            if (this.footerstyle) {
                style.push(this.footerstyle)
            }

            return style.join(';');
        },
    },
}
</script>

<style lang="scss">
.box-shadow-none {
    box-shadow: none !important;
}
</style>

<style lang="sass">
.card--tabs
    box-shadow: none !important
</style>